import { useFormContext, useWatch } from 'react-hook-form';

import { useGetChangeTasksQuery } from '@xemplo/amendment-query';
import { ChangeTaskTypes } from '@xemplo/gp-types';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export const ChangeTask = () => {
  const { control, resetField, unregister } = useFormContext<FormFields>();
  const changeType = useWatch({ control, name: 'changeType' });

  const { data, isLoading } = useGetChangeTasksQuery({
    requestParams: { q: { changeTypeId: changeType } },
  });

  const parsedData =
    data?.result?.rows.map((item) => ({
      key: item.changeTaskValueId,
      value: item.name,
    })) ?? [];

  const changeTaskList = useListBuilder(parsedData);

  return (
    <S.FormLabel>
      Change task
      <V2.TextDropdownRhf
        items={changeTaskList}
        name="changeTask"
        placeholder="Select task"
        aria-label="Change task field"
        data-testid="changeTask"
        disabled={isLoading}
        searchable
        rules={{ required: 'Change task is required' }}
        onChange={(value) => {
          resetField('changeTaskSubType');
          if (value === ChangeTaskTypes.TERMINATION) {
            resetField('appliesTo');
          }

          if (value !== ChangeTaskTypes.ALLOWANCE) {
            unregister('lumpSum');
          }

          if (value === ChangeTaskTypes.PAY_INSTRUCTION) {
            unregister('changeTaskSubType');
            unregister('terminatedWorkers');
            unregister('units');
            unregister('amountMethod');
          }
        }}
      />
    </S.FormLabel>
  );
};
